module.exports = __webpack_public_path__ + "index/img/noCollection.84afa3b0.png";